export default {
  apis: ['users','v3', 'lowest-rate-calendar', 'check-mop']
}
